import * as Yup from 'yup';
import { useRef, useState, FC } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';

type CreateEditProps = {
  closeCreateEditForm: any;
  vehichleTypeEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  vehichleTypeEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const regExp = /^(\d+(?:[\.\,]\d{2})?)$/;

  const VehichleTypeSchema = Yup.object().shape({
    vehichleType: Yup.string()
      .required('Vehicle Name is required')
      // .test(
      //   "vehicle-name",
      //   "Vehicle Type must be alphabetic or alphanumeric",
      //   (value) => {
      //     if (isNaN(parseFloat(value))) {
      //       return true;
      //     } else {
      //       let numberPart = parseFloat(value).toString();
      //       if (numberPart.length < value.length) {
      //         return true;
      //       } else {
      //         return false;
      //       }
      //     }

      //   })
      //   .trim('Vehicle Type cannot include leading and trailing spaces')
      .min(3, 'Vehicle Name must be at least 3 character')
      // .matches(
      //   // eslint-disable-next-line no-useless-escape
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Vehicle Name only accepts special characters like &,[,],-,/,(,)'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Vehicle Name must include at least one letter of the alphabet'
      // )
      .test(
        'no-leading-space',
        'Cannot start with a space',
        (value) => !value || value.trimStart() === value
      ),

    vehichleRate: Yup.number()
      //.required('Vehicle Rate is required')
      //.typeError('Vehicle Rate is not valid')
      .positive('Must be a positive number.')
      .min(1, 'Vehicle Rate must be greater than or equal to 1')
      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .test(
        'len',
        'Length is too long',
        (val) =>
          !val ||
          (val && val.toString().includes('.')
            ? val.toString().length <= 10
            : val.toString().length <= 8)
      )
      .test(
        'max-two-decimals',
        'Vehicle Rate can have at most 2 decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
  });

  const cancelClickedFlag = useRef(false);
  const [productLoader, setProductLoader] = useState(null);
  const [policyProductData, setPolicyProductData] = useState([]);
  const [policyProductValue, setPolicyProductValue] = useState('');
  const [policyProductSearchValue, setPolicyProductSearchValue] = useState('');
  const [noOptionsTextFlag, setNoOptionsTextFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const formik = useFormik({
    initialValues: {
      id: '',
      vehichleType: '',
      productId: productId,
      vehichleRate: '',
      status: true
    },
    validationSchema: VehichleTypeSchema,
    onSubmit: (values) => {
      values.vehichleRate = String(values.vehichleRate);
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'vehichleType',
        method: method,
        data: values
      })
        .then((vehichleType) => {
          if (vehichleType.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.vehichleType);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: vehichleType['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = vehichleTypeEditDatas.id;
    formik.initialValues.vehichleType = vehichleTypeEditDatas.vehichleType;

    formik.initialValues.vehichleRate = vehichleTypeEditDatas.vehichleRate;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  React.useEffect(() => {
    if (editStatus) {
      formik.initialValues.productId = vehichleTypeEditDatas.productId;
      setPolicyProductSearchValue(vehichleTypeEditDatas.policyProduct?.name);
      setPolicyProductValue(vehichleTypeEditDatas.policyProduct);
    }
  }, [editStatus]);
  const handleCancelMouseDown = () => {
    cancelClickedFlag.current = true;
  };

  //Product fdetch api
  React.useEffect(() => {
    getpolicyProductData();
  }, [policyProductSearchValue]);

  const getpolicyProductData = () => {
    setProductLoader(true);
    setPolicyProductData([]);
    request({
      url: 'policyProduct/getAllowedPolicyProducts',
      method: 'post'
    }).then(
      (response: any) => {
        setProductLoader(false);
        if (response?.status == false) {
          setNoOptionsTextFlag(true);
          setPolicyProductData([]);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response.message
          });
        } else {
          setNoOptionsTextFlag(false);
          setPolicyProductData(response);
        }
      },
      (error) => {
        setProductLoader(false);
        console.log(error);
      }
    );
  };
  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Vehicle Type" />
              ) : (
                <CardHeader title="Create Vehicle Type" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label={
                          <React.Fragment>
                            Vehicle Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="vehichleType"
                        value={capitalizeFirst(formik.values.vehichleType)}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.vehichleType &&
                          Boolean(formik.errors.vehichleType)
                        }
                        helperText={
                          formik.touched.vehichleType &&
                          formik.errors.vehichleType
                        }
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label={'Vehicle Rate'}
                        sx={{ width: '100%' }}
                        size="small"
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        name="vehichleRate"
                        value={formik.values.vehichleRate}
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                          if (!cancelClickedFlag.current) {
                            formik.handleBlur(e);
                          }
                        }}
                        error={
                          formik.touched.vehichleRate &&
                          Boolean(formik.errors.vehichleRate)
                        }
                        helperText={
                          formik.touched.vehichleRate &&
                          formik.errors.vehichleRate
                        }
                      />
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          type="submit"
                          variant="contained"
                        >
                          Save
                        </Button>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                        onMouseDown={handleCancelMouseDown}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
